// import * as React from "react";
// import Popover from "@mui/material/Popover";
// import { Typography, Box, Button, IconButton } from "@mui/material";
// import { useState } from "react";
// import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// import MultipleStopIcon from "@mui/icons-material/MultipleStop";

// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setProfileTenantIdR,
//   setProfileNameR,
//   setProfilePictureBase64StringR,
//   setChangeTenantModeR,
//   setNewCurrentPeriodR,
// } from "../../../../scenes/Meeting/MeetingsSlice/MeetingsSlice";
// // import { useDispatch } from 'react-redux';
// import { useGetPriodById } from "../../../Login/Hooks/Index";
// import { NewUseStore } from "../../../../Store/newUseStore";
// export default function TenantsList({
//   ButtonCaption,
//   data,
//   tenantList,
//   setShowTenantItem,
// }: any) {
//   const profileTenantId = useSelector(
//     (state: any) => state.meetings.profileTenantId
//   );
//   const userPhoneNumber: string = useSelector(
//     (state: any) => state.loign.userPhoneNumber
//   );
//   const periodId = useSelector((state: any) => state.meetings.priodId);

//   const updateNewTenantId = NewUseStore((state) => state.updateNewTenantId);

//   const [tenantImgSrc, setTenantImgSrc] = useState<any>(null);
//   const tenantId: string = useSelector(
//     (state: any) => state.meetings.profileTenantId
//   );
//   const [MeetIds, setMeetIds] = useState<any>({
//     tenantId: profileTenantId,
//     priodId: periodId,
//     userPhoneNumber: userPhoneNumber,
//   });
//   var navigate = useNavigate();
//   const [Ids, setIds] = useState<any>(null);
//   const onSuccesss = (): void => {
//     navigate("/dashboard/AllTenantOkrs", { replace: true });
//   };

//   const onFailed = (): void => {};
//   const { data: perData } = useGetPriodById(
//     Ids?.tenantId,
//     onSuccesss,
//     onFailed
//   );
//   // const navigate = useNavigate();
//   const dispatch = useDispatch();
//   // console.log(tenantList)
//   const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
//     null
//   );
//   const [ltenantList, setLTenantList] = React.useState(tenantList);
//   const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const userTenantsData = useSelector(
//     (state: any) => state.loign.userInfo.userTenants
//   );
//   useEffect(() => {
//     if (tenantList) {
//       let tenant = tenantList.filter((u: any) => u.tenantName == ButtonCaption);
//       let { pictureBase64String } = tenant[0];
//       setTenantImgSrc(pictureBase64String);
//     }
//   }, [tenantList]);

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);
//   const id = open ? "simple-popover" : undefined;

//   const initialChangTenents = () => {
//     setShowTenantItem(true);
//   };

//   const initialSelectTenant = (tenant: any) => {
//     let { tenantId, tenantName, pictureBase64String } = tenant;
//     // console.log(tenantId)
//     let ids = {
//       tenantId: tenantId,
//       priodId: "rrr",
//     };
//     // getMeertAgin({tenantId:tenantId,priodId:priodId})
//     updateNewTenantId(tenantId);
//     setIds(ids);
//     dispatch(setProfileTenantIdR(ids));
//     dispatch(setProfileNameR(tenantName));
//     dispatch(setProfilePictureBase64StringR(pictureBase64String));
//     setAnchorEl(null);
//     dispatch(setNewCurrentPeriodR());
//     // console.log(ids)
//   };

//   return (
//     <div>
//       <Box display={"flex"} alignItems={"center"} flexDirection={"row-reverse"}>
//         <Button
//           variant="text"
//           sx={{ color: "black !important" }}
//           onClick={handleClick}
//         >
//           {/* <img src={tenantImgSrc} width={'50px'}   style={{borderRadius:'50%'}}/>  */}
//           <Typography fontWeight={900} fontSize={"13px"}>
//             {ButtonCaption}
//           </Typography>
//         </Button>
//       </Box>
//       <Popover
//         id={id}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "left",
//         }}
//       >
//         <Box
//           width={"280px"}
//           display={"flex"}
//           flexDirection={"column"}
//           alignItems={"start"}
//           justifyContent={"center"}
//           p={1}
//         >
//           <Box
//             width={"100%"}
//             display={"flex"}
//             justifyContent={"space-between"}
//             sx={{ borderRadius: "5px", bgcolor: "#F5F5F5 !important", px: 1 }}
//           >
//             <Box
//               display={"flex"}
//               alignItems={"center"}
//               justifyContent={"center"}
//             >
//               <Typography px={1}>شرکت ها </Typography>
//               <MultipleStopIcon />
//             </Box>
//             <Box>
//               <IconButton size="small" onClick={handleClose}>
//                 <HighlightOffIcon />
//               </IconButton>
//             </Box>
//           </Box>
//           {ltenantList &&
//             ltenantList.map((tenant: any, i: number) => {
//               let { tenantName } = tenant;
//               return (
//                 <Box
//                   key={i}
//                   px={1}
//                   sx={{
//                     backgroundColor:
//                       tenantName === ButtonCaption ? "#F5F5F5" : "",
//                     width: "100%",
//                     borderRadius: "5px",
//                   }}
//                 >
//                   <Typography
//                     py={0.85}
//                     onClick={() => {
//                       initialSelectTenant(tenant);
//                     }}
//                     // #00387C !important

//                     sx={{
//                       width: "100%",
//                       cursor: "pointer",
//                       borderRadius: "5px",
//                     }}
//                     fontWeight={tenantName === ButtonCaption ? 700 : 500}
//                     fontSize={"0.75rem"}
//                     color={tenantName === ButtonCaption ? "black" : "gray"}
//                   >
//                     {tenantName}
//                   </Typography>
//                 </Box>
//               );
//             })}
//         </Box>
//       </Popover>
//     </div>
//   );
// }

import * as React from "react";
import Popover from "@mui/material/Popover";
import { Typography, Box, Button, IconButton } from "@mui/material";
import { useState, useEffect } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setProfileTenantIdR,
  setProfileNameR,
  setProfilePictureBase64StringR,
  setNewCurrentPeriodR,
} from "../../../../scenes/Meeting/MeetingsSlice/MeetingsSlice";
import { useGetPriodById } from "../../../Login/Hooks/Index";
import { NewUseStore } from "../../../../Store/newUseStore";

export default function TenantsList({
  ButtonCaption,
  data,
  tenantList,
  setShowTenantItem,
}: any) {
  const profileTenantId = useSelector((state: any) => state.meetings.profileTenantId);
  const userPhoneNumber: string = useSelector((state: any) => state.loign.userPhoneNumber);
  const periodId = useSelector((state: any) => state.meetings.priodId);

  const updateNewTenantId = NewUseStore((state) => state.updateNewTenantId);

  const [tenantImgSrc, setTenantImgSrc] = useState<any>(null);
  const tenantId: string = useSelector((state: any) => state.meetings.profileTenantId);
  const [MeetIds, setMeetIds] = useState<any>({
    tenantId: profileTenantId,
    priodId: periodId,
    userPhoneNumber: userPhoneNumber,
  });
  const navigate = useNavigate();
  const [Ids, setIds] = useState<any>(null);
  const onSuccesss = (): void => {
    navigate("/dashboard/TenantDash", { replace: true });
  };
  const onFailed = (): void => {};
  const { data: perData } = useGetPriodById(Ids?.tenantId, onSuccesss, onFailed);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [ltenantList, setLTenantList] = React.useState(tenantList);
  
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const userTenantsData = useSelector((state: any) => state.loign.userInfo.userTenants);
  
  useEffect(() => {
    if (tenantList) {
      let tenant = tenantList.filter((u: any) => u.tenantName === ButtonCaption);
      let { pictureBase64String } = tenant[0];
      setTenantImgSrc(pictureBase64String);
    }
  }, [tenantList]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const initialChangTenents = () => {
    setShowTenantItem(true);
  };

  const initialSelectTenant = (tenant: any) => {
    let { tenantId, tenantName, pictureBase64String } = tenant;
    let ids = {
      tenantId: tenantId,
      priodId: "rrr",
    };
    updateNewTenantId(tenantId);
    setIds(ids);
    dispatch(setProfileTenantIdR(ids));
    dispatch(setProfileNameR(tenantName));
    dispatch(setProfilePictureBase64StringR(pictureBase64String));
    setAnchorEl(null);
    dispatch(setNewCurrentPeriodR());
  };

  return (
    <div>
      <Box display={"flex"} alignItems={"center"} flexDirection={"row-reverse"}>
        <Button
          variant="text"
          sx={{ color: "black !important", borderRadius: "8px", px: 2, py: 1 }}
          onClick={handleClick}
        >
<Typography
  fontWeight={900}
  sx={{
    fontSize: { xs: '10px', md: '12px' }, // در موبایل 10px و در دسکتاپ 12px
  }}
>
  {ButtonCaption}
</Typography>

        </Button>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          width={"280px"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"start"}
          justifyContent={"center"}
          p={1}
          sx={{ borderRadius: "8px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)" }}
        >
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            sx={{ borderRadius: "5px", bgcolor: "#F5F5F5 !important", px: 1, py: 1 }}
          >
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
              <Typography px={1}>شرکت ها</Typography>
              <MultipleStopIcon />
            </Box>
            <Box>
              <IconButton size="small" onClick={handleClose}>
                <HighlightOffIcon />
              </IconButton>
            </Box>
          </Box>
          {ltenantList &&
            ltenantList.map((tenant: any, i: number) => {
              let { tenantName } = tenant;
              return (
                <Box
                  key={i}
                  px={1}
                  sx={{
                    backgroundColor: tenantName === ButtonCaption ? "#F5F5F5" : "",
                    width: "100%",
                    borderRadius: "5px",
                  }}
                >
                  <Typography
                    py={0.85}
                    onClick={() => {
                      initialSelectTenant(tenant);
                    }}
                    sx={{
                      width: "100%",
                      cursor: "pointer",
                      borderRadius: "5px",
                      color: tenantName === ButtonCaption ? "black" : "gray",
                      fontWeight: tenantName === ButtonCaption ? 700 : 500,
                      fontSize: "0.75rem",
                    }}
                  >
                    {tenantName}
                  </Typography>
                </Box>
              );
            })}
        </Box>
      </Popover>
    </div>
  );
}
